module.exports = __webpack_public_path__ + "img/image11.3d6acc79.png";